import ListProcesses from "@/views/organization/process/packing/ListProcesses.vue";
import ShowProcess from "@/views/organization/process/packing/ShowProcess.vue";
import ShowHarvestedBatch from "@/views/organization/process/packing/ShowHarvestedBatch.vue"
import NewHarvestedBatch from "@/views/organization/process/packing/NewHarvestedBatch.vue"
import EditHarvestedBatch from "@/views/organization/process/packing/EditHarvestedBatch.vue"
import NewPackage from "@/views/organization/process/packing/NewPackage.vue"
import EditPackage from "@/views/organization/process/packing/EditPackage.vue"

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "org",
  role: "process",
  permission: "packing"
});

export default [
  {
    path: "/org/:organization_id/process/packing/list_processes",
    name: routeName(""),
    redirect: { name: routeName("list_processes") }
  },
  {
    path: "/org/:organization_id/process/packing/list_processes",
    name: routeName("list_processes"),
    component: ListProcesses,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/packing/show_process/:harvest_process_id",
    name: routeName("show_process"),
    component: ShowProcess,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/packing/show_harvested_batch/:harvested_batch_id",
    name: routeName("show_harvested_batch"),
    component: ShowHarvestedBatch,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/packing/new_harvested_batch/:harvest_process_id",
    name: routeName("new_harvested_batch"),
    component: NewHarvestedBatch,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/packing/edit_harvested_batch/:harvested_batch_id",
    name: routeName("edit_harvested_batch"),
    component: EditHarvestedBatch,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/packing/new_package/:harvested_batch_id",
    name: routeName("new_package"),
    component: NewPackage,
    props: true,
    meta: META
  },
  {
    path: "/org/:organization_id/process/packing/edit_package/:package_id/:harvested_batch_id",
    name: routeName("edit_package"),
    component: EditPackage,
    props: true,
    meta: META
  }
];
